var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTrendvizorIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 21,
    viewBox: "0 0 20 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_6007_98416)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.8567 2.17143C12.9307 2.24482 12.9325 2.36428 12.8601 2.43937C12.4504 2.87115 12.0578 3.31487 11.6808 3.77054C10.0073 5.78777 8.65061 8.03198 7.63309 10.4673C7.24226 11.4008 6.90825 12.3497 6.62934 13.3123C6.56736 13.5273 6.24712 13.4829 6.24712 13.2594V5.6666C6.24712 5.55908 6.15932 5.47375 6.05257 5.47375H4.07952C1.87403 5.47204 0.0869141 3.70057 0.0869141 1.51438V0.278786C0.0869141 0.171269 0.17472 0.0859375 0.281465 0.0859375H10.6719C10.7235 0.0859375 10.7734 0.106417 10.8096 0.142256L12.8567 2.17143Z",
    fill: "#211E1F",
    stroke: "#211E1F",
    strokeWidth: 0.0677966,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.9879 0.278539V7.85253C19.9879 8.0249 19.7778 8.11194 19.6539 7.98906L18.4194 6.76541L17.8943 6.24489C17.8168 6.1681 17.6929 6.1681 17.6154 6.24489C13.8122 10.0865 11.679 15.2559 11.679 20.642C11.679 20.7495 11.5912 20.8365 11.4845 20.8365H6.44162C6.33316 20.8365 6.24707 20.7495 6.24707 20.6437C6.24707 13.8274 8.95357 7.28594 13.776 2.43401C13.8518 2.35891 13.8518 2.23774 13.776 2.16265L12.013 0.415069C11.8908 0.293899 11.9769 0.0839844 12.1507 0.0839844H19.7916C19.9001 0.0839844 19.9862 0.171022 19.9862 0.276833L19.9879 0.278539Z",
    fill: "url(#paint0_linear_6007_98416)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.76097 20.8397H6.44357C6.33511 20.8397 6.24902 20.7527 6.24902 20.6469C6.24902 13.8306 8.95552 7.28911 13.778 2.43718C13.8537 2.36209 13.8537 2.24092 13.778 2.16583L12.015 0.419952C11.8927 0.298782 11.9788 0.0888672 12.1527 0.0888672H19.4217C19.6059 0.0888672 19.6868 0.319261 19.5422 0.433605C9.0726 8.67318 8.91764 19.0904 8.95552 20.6434C8.95896 20.7527 8.86944 20.8414 8.76097 20.8414V20.8397Z",
    fill: "url(#paint1_linear_6007_98416)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_6007_98416",
    x1: 6.24707,
    y1: 10.462,
    x2: 19.9879,
    y2: 10.462,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E97B24"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.97,
    stopColor: "#E97B24"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E97B24"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_6007_98416",
    x1: 6.84645,
    y1: 20.6707,
    x2: 15.6829,
    y2: 0.161776,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF9800"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E97B24"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_6007_98416"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 21,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrendvizorIcon);
export default __webpack_public_path__ + "static/media/trendvizor_icon.6344acb878cc1e75028b97bfa90c9e35.svg";
export { ForwardRef as ReactComponent };